var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"white--text rounded-lg primarybtn",attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"depressed":"","block":_vm.block,"x-large":_vm.large},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }